import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const IconInstagram = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="18"
    height="18"
    aria-hidden="true"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" stroke="none" />
  </svg>
);

function Footer() {
  return (
    <footer className="ab-footer">
      <div className="ab-footer-inner">
        <div className="ab-footer-brand">
          <span className="ab-footer-logo">Branch <span>&gt; development</span></span>
          <p className="ab-footer-copy">Todos los derechos reservados.</p>
        </div>
        <nav className="ab-footer-nav">
          <Link to="/">Inicio</Link>
          <span className="ab-footer-sep">|</span>
          <Link to="/about">Quiénes somos</Link>
          <span className="ab-footer-sep">|</span>
          <Link to="/contacto" className="ab-footer-cta">Contáctanos</Link>
          <span className="ab-footer-sep">|</span>
          <a
            href="https://www.instagram.com/branchdevelopmentar/"
            target="_blank"
            rel="noreferrer"
            className="ab-footer-social"
            aria-label="Instagram"
          >
            <IconInstagram />
          </a>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;

